module.exports = __webpack_public_path__ + "img/Download - White - Selected.3f03f9dd.png";